import {Component, NgZone, OnInit} from '@angular/core';
import {
  AddApprovalFlowStagesListComponent
} from '../add-approval-flow-stages-list/add-approval-flow-stages-list.component';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {SettingsService} from 'src/app/services/settings.service';
import {AppState} from 'src/app/store/reducers';
import {
  ApprovalFlowStages
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.model';
import {
  createApprovalFlowStageSuccessorMutation,
  getApprovalFlowStages,
  removeApprovalFlowStagesMutation,
  removeApprovalFlowStageSuccessorMutation
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.actions';
import {
  selectModifiedApprovalFlowStages
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.selectors';
import {ActivatedRoute} from '@angular/router';
import {
  ApprovalFlowSuccessor
} from 'src/app/store/entities/instution-settings/approval-flow-successor/approval-flow-successor.model';
import {
  AddApprovalFlowSuccessorComponent
} from '../../approval-flow-successor/add-approval-flow-successor/add-approval-flow-successor.component';
import {
  getAllProcessApprovalFlows
} from "../../../../../store/entities/instution-settings/approval-flow/approval-flow.actions";
import {ApprovalFlow} from "../../../../../store/entities/instution-settings/approval-flow/approval-flow.model";
import {
  selectModifiedApprovalFlowByUuid
} from "../../../../../store/entities/instution-settings/approval-flow/approval-flow.selectors";
import {ConcatPipe} from "../../../../pipes/concat.pipe";

@Component({
  selector: 'app-approval-flow-stages-list',
  templateUrl: './approval-flow-stages-list.component.html',
  styleUrls: ['./approval-flow-stages-list.component.scss']
})
export class ApprovalFlowStagesListComponent implements OnInit {

  tableColumns: object;
  approvalFlowStages: ApprovalFlowStages[];
  tableData$: Observable<ApprovalFlowStages[]>;
  selectedApprovalFlow$: Observable<ApprovalFlow>


  successor:ApprovalFlowSuccessor;
  flowUniqueId:string;
  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private activeRoute: ActivatedRoute,
    private ngZone: NgZone
  ) {
    this.flowUniqueId = this.activeRoute.snapshot.paramMap.get('flowUniqueId');
  }

  ngOnInit(): void {

    this.store.dispatch(getApprovalFlowStages({flowUniqueId:this.flowUniqueId}));
    this.store.dispatch(getAllProcessApprovalFlows({filtering:{
        flowProcess:null,
        flowUniqueId: this.flowUniqueId
      }}))

    this.tableColumns = {
      no: 'SN',
      stageName: 'Name',
      stageIsStartingmdo:'Stage Is Starting',
      stageIsEndingmod:'Stage Is Ending',
      stageDesignationMod:'Designation',
      successorStageMod: 'Successor Stage',
      actions: 'Actions'
    }

    this.tableData$ = this.store.pipe(select(selectModifiedApprovalFlowStages));

    this.tableData$.subscribe(data => {
      if (data) {
        this.approvalFlowStages = data
      }
    })
    this.selectedApprovalFlow$ = this.store.pipe(select(selectModifiedApprovalFlowByUuid(this.flowUniqueId)))

  }


  setStageSuccessor(currentStage: string, successor: string) {
    let currentStageUniqueId = this.approvalFlowStages.find(s => new ConcatPipe().transform(s.stageName) === currentStage)?.stageUniqueId
    let successorUniqueId = this.approvalFlowStages.find(s => new ConcatPipe().transform(s.stageName) === successor)?.stageUniqueId

    this.ngZone.run(() => {
      this.store.dispatch(
        createApprovalFlowStageSuccessorMutation({
          successor: {
            successorStage: successorUniqueId,
            successorCurrentStage: currentStageUniqueId
          },
        })
      );
    })
  }


  addEditStagesFlow(stages: ApprovalFlowStages = null): void {
    this.settingsService.openDialogModal({
      component: AddApprovalFlowStagesListComponent,
      width: '50%',
      data: {stages,flowUniqueId:this.flowUniqueId}
    })
  }

  addSuccessor(stages: ApprovalFlowStages,successor: ApprovalFlowSuccessor = null): void {
    this.settingsService.openDialogModal({
      component: AddApprovalFlowSuccessorComponent,
      width: '50%',
      data: {successor,stages}
    })
  }

  deleteApprovalFlowStages(stages: ApprovalFlowStages): void {
    const message = 'Are you sure?';
      this.notificationService.confirmation(message, 'Delete').then((data) => {
        if(data.value){
          this.store.dispatch(removeApprovalFlowStagesMutation({ stageUniqueId: stages.stageUniqueId, id: stages.id}));
        }
      })
  }

  deleteApprovalSuccessor(stages: ApprovalFlowStages): void {
    const message = 'Are you sure?';
      this.notificationService.confirmation(message, 'Delete').then((data) => {
        if(data.value){
          this.store.dispatch(removeApprovalFlowStageSuccessorMutation({successorUniqueId: stages.successorStage?.uuid}));
        }
      })
  }
}
